import React, { useRef } from 'react';
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";

const Banner = () => {
  const sliderRef = useRef(null);

  const settings = {
    dots: true,
    infinite: true,
    autoplay: true,
    speed: 800,
    autoplaySpeed: 4000,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false, // Slick oklarını devre dışı bırakıyoruz
  };

  return (
    <section className="banner-section">
      <div className="banner-carousel-wrapper">
        <Slider {...settings} ref={sliderRef} className="banner-carousel">
          {/* Slide 1 */}
          <div className="slide-item">
            <div
              className="bg-image"
              style={{
                backgroundImage: "url(/assets/images/main-slider/2.jpg)",
                backgroundSize: "cover",
                backgroundPosition: "center",
                height: "100vh"
              }}
            >
              <div className="auto-container">
                <div className="content-box">
                  <span className="sub-title">Solutions for all type of visas</span>
                  <h1 className="title">TATİL YERİNİZİ SEÇİN<br />VİZENİZİ ALALIM</h1>
                  <div className="btn-box">
                    <a className="theme-btn btn-style-one" href="page-about.html">
                      <span className="btn-title">Şimdi Keşfet</span>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Slide 2 */}
          <div className="slide-item">
            <div
              className="bg-image"
              style={{
                backgroundImage: "url(/assets/images/main-slider/1.jpg)",
                backgroundSize: "cover",
                backgroundPosition: "center",
                height: "100vh"
              }}
            >
              <div className="auto-container">
                <div className="content-box">
                  <span className="sub-title">Çin Vizeleri JET Hızında</span>
                  <h1 className="title">VİZENİZİ ALIN ÇİN'İN FUAR DÖNEMİNE YETİŞİN</h1>
                  <div className="btn-box">
                    <a className="theme-btn btn-style-one" href="page-about.html">
                      <span className="btn-title">Şimdi Keşfet</span>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Slider>

        {/* Custom Navigation */}
        <div className="owl-nav custom-arrows">
          <div className="owl-prev" onClick={() => sliderRef.current?.slickPrev()}>
            <span className="fa fa-long-arrow-alt-left"></span>
          </div>
          <div className="owl-next" onClick={() => sliderRef.current?.slickNext()}>
            <span className="fa fa-long-arrow-alt-right"></span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Banner;